import { formatPrice, isToday  } from "@shared/Utils";
import {CompletedTransaction} from "@sharedtypes/CompletedTransactions";
import {CASH, DEBIT, CREDIT, CONTRA} from '@constants/payment_types';
import {GOOD, REFUNDED} from '@constants/status_types'
import dateFormat from "dateformat";
import { FLOORS } from "@constants/floors";
import { CheckCircleIcon } from '@heroicons/react/20/solid';

export const COLUMNS = [
  {
    "id": "stallholder",
    "label": "Dealer",
    "cellStyle": (row: number) => "pl-2 py-1 sm:text-sm md:text-md lg:text-lg",
    "headerStyle": "",
    "format": (cell: any, row: {}, index: number) => { 

      const transaction = row as CompletedTransaction;
      const date = new Date(transaction.timestamp);

      if (!isToday(date))
        return (<>{cell.id}</>);
      return (
        <div className="grid grid-cols-1 w-32"> 
          <div className="">
            {cell.id}
          </div>
          <div className="text-sm">
            {cell.name }
          </div>
        </div>
      );
    }
  },
  {
    "id": "price",
    "label": "Price",
    "cellStyle": (row: number) => "print:p-0 print:m-0 print:text-xs pl-2 py-1  sm:text-sm md:text-md lg:text-lg text-left  ",
    "headerStyle": "print:p-0 print:m-0 pl-2 py-1 text-left ",
    "format": (cell: any, row: {}, index: number) => { 

      const price = formatPrice(cell);

      const transaction = row as CompletedTransaction;
      if (transaction.status === GOOD)
        return price;
      return <div className="line-through">{price}</div>
    }
  },
  {
    "id": "price",
    "label": "Net",
    "cellStyle": (row: number) => "print:p-0 print:m-0 print:text-xs pl-2 py-1  sm:text-sm md:text-md lg:text-lg text-left ",
    "headerStyle": "print:p-0 print:m-0 pl-2 py-1 text-left ",
    "format": (cell: any, row: {}, index: number) => { 

      const transaction = row as CompletedTransaction;
      if (transaction.status === GOOD) {
        return formatPrice(transaction.net);
      }
      else if (transaction.status === REFUNDED) {
        if (transaction.paymentType === DEBIT) {
          return formatPrice(transaction.net);
        }
      }
      return <div className="">-</div>
    }
  },
  {
    "id": "description",
    "label": "Description",
    "cellStyle": (row: number) => "print:p-0 print:m-0 print:text-xs py-1 sm:text-sm md:text-md lg:text-lg",
    "headerStyle": "py-1",
    "format": (cell: any, row: {}, index: number) => {
      return (
        <p className="print:truncate">
          {cell}
        </p>
      );
    }
  },
  {
    "id": "stockid",
    "label": "Stock ID",
    "cellStyle": (row: number) =>  "print:p-0 print:m-0 print:text-xs py-1 sm:text-sm md:text-md lg:text-lg",
    "headerStyle": "py-1 print:text-xs ",
    "format": (cell: any, row: {}) => {
      return (
        <p className="print:max-w-[60px] print:truncate lg:w-48 sm:w-24">
          {cell}
        </p>
      );
    }
  },

  {
    "id": "timestamp",
    "label": "Date",
    "cellStyle": (row: number) => "print:p-0 print:m-0 print:text-xs pl-2 py-1 sm:text-sm md:text-md lg:text-lg",
    "headerStyle": "pl-2 py-1",
    "format": (cell: any, row: {}, index: number) => { 
      const date = new Date(cell);
      return dateFormat(date, "mmm dS HH:MM");
      /*
      
      if (isToday(date)) return dateFormat(date, "h:MM");
      return <p className="w-32">{dateFormat(date, "d mmmm")}</p>;
      */
    }
  },
  {
    "id": "floor",
    "label": "Floor",
    "cellStyle": (row: number) => "pl-2 py-1 sm:text-sm md:text-md lg:text-lg",
    "headerStyle": "pl-2  py-1",
    "format": (cell: any, row: {}, index: number) => { 
      return FLOORS[cell]
    }
  },
  {
    "id": "till",
    "label": "till",
    "cellStyle": (row: number) => "pl-2 py-1 sm:text-sm md:text-md lg:text-lg",
    "headerStyle": "pl-2  py-1"
  },
  {
    "id": "paymentType",
    "label": "Payment",
    "cellStyle": (row: number) => "pl-2 py-1 sm:text-sm md:text-md lg:text-lg",
    "headerStyle": "pl-2  py-1",
    "format": (cell: any, row: {}, index: number) => { 
      
      if(cell === CASH)
        return "Cash";
      else if(cell === DEBIT)
        return "Debit";
      else if(cell === CREDIT)
        return "Credit"
      else if(cell === CONTRA)
        return "Contra"
      return "Error: Unknown type"
    }
  },
  {
    "id": "id",
    "label": "Sales ID",
    "cellStyle": (row: number) => "pl-2  py-1 font-medium sm:text-sm md:text-md lg:text-lg text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800",
    "headerStyle": "pl-2  py-1 bg-gray-50 dark:bg-gray-800"
  },
  {//10
    "id": "isQPitch",
    "label": "Q",
    "cellStyle": (row: number) => "pl-2 py-1 text-lg",
    "headerStyle": "pl-2  py-1",
    "format": (cell: any, row: {}, index: number) => { 
      if(cell)
        return <CheckCircleIcon className="h-6 w-6 text-green-500"/>;
      else 
        return "";
    }
  },
  {//11
    "id": "isCNP",
    "label": "CNP",
    "cellStyle": (row: number) => "py-1 text-lg",
    "headerStyle": "py-1",
    "format": (cell: any, row: {}, index: number) => { 
      if(cell)
        return <CheckCircleIcon className="h-6 w-6 text-green-500"/>;
      else 
        return "";
    }
  },
]